export enum HistoryReasonTypeEnum {
    None = 0,
    DriverLicense = 1,
    PersonalDetails = 2,
    ApplicationForm = 3,
    Nationality = 4,
    NBIClearance = 5,
    VaccineCard = 6,
    VehicleDetails = 7,
    OR = 8,
    CR = 9,
    SPAorAL = 10,
    PaCpcTasReceipt = 11,
    PAMI = 12,
    ComprehensiveInsurance = 13,
    ApplicationDetails = 14,
    CompetitorsId = 15,
    SPAorLOA = 16,
    PaOrCpc = 17,
    MedicalCertificate = 18
}
